module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3mNVh"))).then(() => parcelRequire('9Lwss'));